/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Front/theme';

export const FrontTheme = theme;
